<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Booking Details</h2>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && booking">

    <!-- Header Card -->
    <div class="bg-white p-6 rounded-2xl shadow flex justify-between items-center">
        <div>
            <h2 class="text-2xl font-semibold">
                Booking #{{ booking.id }}
            </h2>

            <div class="flex gap-3 mt-3">
                <app-badge [color]="getBadgeColor(booking.status)">
                    {{ booking.status }}
                </app-badge>
            </div>
        </div>

        <div class="text-right">
            <p class="text-gray-500">Service</p>
            <p class="font-medium">{{ booking.service?.name ?? '—' }}</p>
            <p class="text-gray-500 mt-2">Amount</p>
            <p class="font-medium">${{ booking.amount | number:'1.2-2' }}</p>
        </div>
    </div>

    <!-- User & Mechanic -->
    <div class="grid grid-cols-2 gap-6">

        <div class="bg-white p-6 rounded-2xl shadow">
            <h3 class="font-semibold mb-4 text-gray-800">User Information</h3>
            <ng-container *ngIf="booking.user; else noUser">
                <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Name:</strong> {{ booking.user.name }}</p>
                <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Phone:</strong> {{ booking.user.phone }}</p>
                <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Email:</strong> {{ booking.user.email }}</p>
            </ng-container>
            <ng-template #noUser><p class="text-gray-500">No user information available.</p></ng-template>
        </div>

        <div class="bg-white p-6 rounded-2xl shadow">
            <h3 class="font-semibold mb-4 text-gray-800">Mechanic Information</h3>
            <ng-container *ngIf="booking.mechanic; else noMechanic">
                <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Name:</strong> {{ booking.mechanic.name }}</p>
                <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Phone:</strong> {{ booking.mechanic.phone }}</p>
                <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Email:</strong> {{ booking.mechanic.email }}</p>
            </ng-container>
            <ng-template #noMechanic><p class="text-gray-500">No mechanic assigned.</p></ng-template>
        </div>

    </div>
    
    <!-- Booking Details -->
    <div class="bg-white p-6 rounded-2xl shadow">
        <h3 class="font-semibold mb-4 text-gray-800">Location & Timing</h3>
        <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Type:</strong> <span class="capitalize">{{ booking.type.replace('_', ' ') }}</span></p>
        <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Pickup Address:</strong> {{ booking.pickup_address }}</p>
        <p *ngIf="booking.dropoff_address" class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Dropoff Address:</strong> {{ booking.dropoff_address }}</p>
        <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Scheduled At:</strong> {{ (booking.scheduled_at | date:'medium') ?? 'N/A' }}</p>
        <p class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Created At:</strong> {{ booking.created_at | date:'medium' }}</p>
        <p *ngIf="booking.notes" class="text-gray-600 mb-2"><strong class="text-gray-800 font-medium">Notes:</strong> {{ booking.notes }}</p>
    </div>

    <!-- Admin Controls -->
    <div class="bg-red-50 p-6 rounded-2xl border border-red-200 mt-6">
        <h3 class="font-semibold mb-4">Admin Controls</h3>

        <div class="flex items-end gap-3 mb-4">
            <div class="flex-1 max-w-sm">
                <label class="block text-sm font-medium text-gray-700 mb-1">Assign Mechanic</label>
                <select [(ngModel)]="selectedMechanicId" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500 outline-none">
                    <option [ngValue]="null">Select a Mechanic</option>
                    <option *ngFor="let m of mechanics" [ngValue]="m.id">{{ m.name }} ({{ m.email }})</option>
                </select>
            </div>
            <button 
                (click)="assignMechanic()"
                [disabled]="!selectedMechanicId || isAssigning"
                class="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 disabled:opacity-50 transition">
                {{ isAssigning ? 'Assigning...' : 'Assign Mechanic' }}
            </button>
        </div>

        <div class="flex gap-3 pt-4 border-t border-red-200">
            <button class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition">
                Cancel Booking
            </button>
        </div>
    </div>

  </ng-container>
</div>